import React from "react";
import {
  useAssignProjectToPortfolio,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";

import { ProjectPortfolioTag } from "@common/projectPortfolioTag";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectPortfolio({ project, portfolio }: Props) {
  const { assignProjectToPortfolio, isRequestPending } =
    useAssignProjectToPortfolio(project, portfolio);
  const { planzone } = useRetrieveCurrentPlanzone();

  return (
    <div
      className={styles.projectPortfolio}
      onClick={() =>
        !isRequestPending &&
        assignProjectToPortfolio({ project, portfolio, planzone })
      }
    >
      <ProjectPortfolioTag {...portfolio} />
    </div>
  );
}

export { ProjectPortfolio };
